import imageMapResize from 'image-map-resizer';

document.querySelectorAll('map').forEach(() => {
  imageMapResize();
});
